import { FetchStudentInfo } from "api";
import { StudentIDState, StudentInfoState } from "global-states";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

export function useStudentInfo() {
  const studentID = useRecoilValue(StudentIDState);
  const [student, setStudent] = useRecoilState(StudentInfoState);
  const [error, setError] = useState("");
  useEffect(() => {
    if (studentID === "") return
    FetchStudentInfo(studentID)
      .then((res) => {
        setStudent(res.data.data);
      })
      .catch((err) => {
        setError(JSON.stringify(err));
      });
  }, [setStudent, studentID]);

  return {
    student,
    error,
  };
}
